import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
  Image,
  Skeleton,
  IconButton,
  HStack,
  Tooltip,
} from "@chakra-ui/react";
import FileViewer from "react-file-viewer";
import { FiDownload, FiMaximize2, FiMinimize2 } from "react-icons/fi";

const DocumentViewerModal = ({ isOpen, onClose, document }) => {
  console.log("🚀 ~ DocumentViewerModal ~ document:", document)
  const isPDF = document?.fileType === "pdf";
  const [imageLoading, setImageLoading] = useState(true);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const onError = (e) => {
    console.log("Error in file viewer:", e);
  };

  const handleDownload = () => {
    if (document?.url) {
      window.open(document.url, "_blank");
    }
  };

  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen);
  };

  const getFileNameFromUrl = (url) => {
    try {
      if (!url) return 'Unknown File';
      
      // Decode URL to handle special characters
      const decodedUrl = decodeURIComponent(url);
      
      // Extract filename from URL
      const fileName = decodedUrl.split('/').pop();
      
      // Remove any query parameters if present
      const cleanFileName = fileName.split('?')[0];
      
      // Handle empty or invalid filenames
      return cleanFileName || 'Unknown File';
    } catch (error) {
      console.error('Error extracting filename:', error);
      return 'Unknown File';
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size={isFullscreen ? "full" : "6xl"}
      isCentered
    >
      <ModalOverlay backdropFilter="blur(4px)" />
      <ModalContent maxH="90vh">
        <ModalHeader
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          pr="14"
        >
          {document?.name ? `${document.name} - ` : ''}{getFileNameFromUrl(document?.url)}
          <HStack spacing={2}>
            <Tooltip label="Download">
              <IconButton
                icon={<FiDownload />}
                onClick={handleDownload}
                variant="ghost"
                aria-label="Download document"
                size="sm"
              />
            </Tooltip>
            <Tooltip label={isFullscreen ? "Exit Fullscreen" : "Fullscreen"}>
              <IconButton
                icon={isFullscreen ? <FiMinimize2 /> : <FiMaximize2 />}
                onClick={toggleFullscreen}
                variant="ghost"
                aria-label="Toggle fullscreen"
                size="sm"
              />
            </Tooltip>
          </HStack>
        </ModalHeader>
        <ModalCloseButton position="absolute" right="2" top="2" />

        <ModalBody p={0}>
          {isPDF ? (
            <Box h="80vh" w="100%">
              <FileViewer
                fileType="pdf"
                filePath={document?.url}
                onError={onError}
              />
            </Box>
          ) : (
            <Box
              position="relative"
              h="80vh"
              overflow="auto"
              css={{
                "&::-webkit-scrollbar": {
                  width: "4px",
                },
                "&::-webkit-scrollbar-track": {
                  width: "6px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#E2E8F0",
                  borderRadius: "24px",
                },
              }}
            >
              <Skeleton
                isLoaded={!imageLoading}
                fadeDuration={1}
                h="100%"
                w="100%"
              >
                <Image
                  src={document?.url}
                  alt={document?.name}
                  maxH="none"
                  mx="auto"
                  objectFit="contain"
                  onLoad={() => setImageLoading(false)}
                  opacity={imageLoading ? 0 : 1}
                  transition="opacity 0.3s ease-in-out"
                />
              </Skeleton>
            </Box>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default DocumentViewerModal;
